/** Get blob from Guideline.js and QuoteArchive.js.
 * Flow:
 * Server Blob (base64 encoding) -> Read with FileReader and clean up base64 -> Decode to Uint8Array -> Create ZIP-format Blob -> Generate object URL => Trigger download
 */
export default function DownloadBlobAsZip(title, blob) {
    /** Create the instance of FileRreader class. */
    const reader = new FileReader();

    // Event handler triggered after a file has been read completely without errors.
    reader.onload = function (event) {
        // The base64 string must not contain whitespace.
        const base64String = event.target.result.replace(/\s/g, '');

        // The length of the base64 string must be divisible by 4. If it's not, append '=' to the end of the string.
        while (base64String.length % 4 !== 0) {
            base64String += '=';
        }

        // Decode the base64 format to retrieve the binary data.
        const decodedString = atob(base64String);

        // Create a utf-8 array and save the corresponding ascii values in a buffer.
        const arrayBuffer = new Uint8Array(decodedString.length);
        for (let i = 0; i < decodedString.length; i++) {
            arrayBuffer[i] = decodedString.charCodeAt(i);
        }

        // Generate a new zip type blob from the buffer.
        const zipBlob = new Blob([arrayBuffer], { type: 'application/zip' });
        // Create a downloadable link for the zip file.
        const link = document.createElement('a');
        const url = URL.createObjectURL(zipBlob);
        link.href = url;
        link.target = '_blank';
        link.download = title;
        link.click();

        setTimeout(() => {
            window.URL.revokeObjectURL(url);
        }, 1000);
        link.remove();
    };
    reader.readAsText(blob);
}
